import { CountUp } from 'countup.js';

import { equalWidths, throttle } from './functions';

// Document load/ready promise, calls 'ready' method when completed
HTMLDocument.prototype.ready = function () {
  return new Promise(function(resolve, reject) {
    if (document.readyState === 'complete') {
      resolve(document);
    } else {
      document.addEventListener('DOMContentLoaded', function() {
        resolve(document);
      });
    }
  });
};



document.ready().then(function() {
  const statsSections = document.getElementsByClassName('section--statistics');
  for(const $statSection of statsSections) {
    createObserver($statSection);
  }
});



function handleIntersect(entries, observer) {
  entries.forEach((entry) => {
    // How much of the entry needs to be in view in order to trigger
    if (entry.intersectionRatio >= .15) {
      animateStats(entry.target);
      
      // Stop watching element
      observer.unobserve(entry.target);
    }
  });
}

function createObserver(element) {
  let observer;

  let options = {
    root: null,
    rootMargin: "0px",
    threshold: [0, .25, .5, .75, 1]
  };

  observer = new IntersectionObserver(handleIntersect, options);
  observer.observe(element);
}


function animateStats(parent) {
  const stats = parent.getElementsByClassName('section__number');
  for(const $stat of stats) {
    const number = Number($stat.dataset.number);
    const options = { duration: 2.5 };
    
    if(Number.isInteger(number) !== true) {
      // Modify settings
      options.decimalPlaces = 1;
    }
    
    const countUp = new CountUp($stat, number, options);
    countUp.start(function() {
      // callback
    });
  }
}